import { Banner } from '@procore/core-react'
import React, { type PropsWithChildren } from 'react'

export const EditorError = ({ children }: PropsWithChildren<{}>) => {
  return (
    <Banner variant="error">
      <Banner.Content>
        <Banner.Body>{children}</Banner.Body>
      </Banner.Content>
    </Banner>
  )
}
